import React from 'react';

/**
 * Numbered insight rows: a mono counter in a narrow column, the statement beside it.
 * Items are React nodes because most of them bold a figure mid-sentence.
 */
const InsightList = ({ items, divided = false, columns = 1 }) => {
  const rows = items.filter(Boolean);

  return (
    <div
      className='grid'
      style={
        columns > 1
          ? { gridTemplateColumns: `repeat(${columns}, 1fr)`, columnGap: 40, rowGap: 18 }
          : { gap: 14 }
      }
    >
      {rows.map((item, index) => (
        <div
          key={index}
          className={`grid items-start gap-ds-3 text-ts-md text-gray-800 ${
            columns > 1 ? 'leading-[1.65]' : ''
          } ${divided && index < rows.length - 1 ? 'border-b border-gray-300 pb-[14px]' : ''}`.trim()}
          style={{ gridTemplateColumns: '20px 1fr' }}
        >
          <span className='pt-[3px] font-jetbrains-mono text-[12px] text-gray-400'>
            {String(index + 1).padStart(2, '0')}
          </span>
          <span>{item}</span>
        </div>
      ))}
    </div>
  );
};

export default InsightList;
